module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/admin-hotel-merge/admin-hotel-merge.html
// module id = 644
// module chunks = 0